import { COMPANY_LOGOS } from './constants';
import styles from './SocialProof.module.scss';

export const SocialProof = () => {
  return (
    <div className={styles.container}>
      <p className={styles.heading}>
        Trusted by millions of users and hundreds of businesses around the world
      </p>
      <div className={styles.marqueeWrapper}>
        <div className={styles.gradientLeft} />
        <div className={styles.gradientRight} />
        <div className={styles.marquee}>
          <div className={styles.marqueeTrack}>
            {[...COMPANY_LOGOS, ...COMPANY_LOGOS].map((company, index) => (
              <div key={`${company.name}-${index}`} className={styles.logoItem}>
                <img
                  src={company.logoUrl}
                  alt={company.name}
                  className={styles.logo}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
